import { getNeighbors } from '../data/states';

export function calculatePoints(playerState: string, plateState: string): number {
  if (plateState === playerState) return 0;
  if (plateState === 'MEX' || plateState === 'CAN') return 20;
  if (playerState === 'HI') return 10;
  if (plateState === 'AK' || plateState === 'HI') return 10;
  if (playerState === 'AK') return 6;
  const neighbors = getNeighbors(playerState);
  if (neighbors.includes(plateState)) return 1;
  return 6;
}

export function getPointsLabel(playerState: string | null, plateState: string): string {
  if (!playerState) return '?';
  const pts = calculatePoints(playerState, plateState);
  if (pts === 0) return 'Home';
  return `+${pts}`;
}
